export default {
  en: {
    historyDep: 'History Department',
    about: 'About',
    oare: 'Old Assyrian Research Environment',
    search: 'Search',
    welcome: 'Welcome',
    login: 'Log In or Sign Up',
    logout: 'Log Out',
  },
  tr: {
    historyDep: 'Tarih Bölümü',
    about: 'Hakkında',
    oare: 'Eski Asur Araştırma Ortamı',
    search: 'Arama',
    welcome: 'Hoşgeldiniz',
    login: 'Giriş yap veya Üye ol',
    logout: 'Çıkış Yap',
  },
};
